import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'label-select-pair',
    templateUrl: 'label-select-pair.component.html',
    styleUrls: ['./label-select-pair.component.css']
})
export class LabelSelectPairWidget {
    @Input() label:string;
    private  _required:any;
    private  _disabled:any;
    @Input() model:any;
    @Input() icon:string;
    @Input() invalid: boolean = false;
    @Input() large:boolean;
    @Input() options: Array<{ value: any; name: string }> = [{value:true,name:'Yes'},{value:false,name:'No'}];

    @Output() modelChange: EventEmitter<any> = new EventEmitter();


    @Input()
    set required(required: string) {
        this._required = required === "" || required === "true";

    }

    get required(): string { return this._required; }

    @Input()
    set disabled(disabled: string) {
        this._disabled = disabled === "" || disabled === "true";

    }

    get disabled(): string { return this._disabled; }


    onChanges(newValue) {
        this.model = newValue;
        this.modelChange.emit(newValue);
    }
}
